import { useEffect, useState } from 'react';
import { sessionLimitRemainingSec } from '../lib/liveAvatarSessionLimit';

function formatRemaining(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, '0')}`;
}

type Props = {
  /** Absolute wall-clock session cap (ms), aligned with LA mint + client timers. */
  endsAtMs: number;
  visible: boolean;
};

/**
 * Subtle time-remaining pill on the avatar stage (LiveAvatar FULL session cap).
 */
export function SessionCountdown({ endsAtMs, visible }: Props) {
  const [remainingSec, setRemainingSec] = useState(0);

  useEffect(() => {
    if (!visible || !endsAtMs) return;
    const tick = () => setRemainingSec(sessionLimitRemainingSec(endsAtMs));
    tick();
    const id = window.setInterval(tick, 250);
    return () => window.clearInterval(id);
  }, [visible, endsAtMs]);

  if (!visible || !endsAtMs) return null;

  const urgent = remainingSec > 0 && remainingSec <= 15;

  return (
    <div
      className={`session-countdown${urgent ? ' is-urgent' : ''}`}
      role="timer"
      aria-live="off"
      aria-label={`Time remaining in session: ${formatRemaining(remainingSec)}`}
    >
      <span className="session-countdown-label">Time left</span>
      <span className="session-countdown-value">{formatRemaining(remainingSec)}</span>
    </div>
  );
}
